export default {
  sections: {
    payment: 'Maksu',
  },
  labels: {
    proceed_to_payment: 'Jatka maksuun linkin kautta tai skannaa QR-koodi',
  },
  buttons: {
    generate_new_link: 'Luo uusi linkki',
    copy_link: 'Kopioi linkki',
    pay_now: 'Maksa nyt',
  },
  toasts: {
    failed_to_create_payment_link: 'Maksulinkin lataaminen epäonnistui',
  },
};
